import coreStore from "./core-store";

const remoteResource = 'operation/api/v1/queries';

const store = coreStore.createCoreStore('operationQuery', remoteResource, 'operationQueries')

store.getters.operationQuery = (state) => (name) => {
    let objs = state.operationQueries.filter(item => item.name == name);
    return objs.length != 0 ? objs[0] : null;
}

store.getters.operationQueryById = (state) => (id) => state.operationQueries.find(item => item.id === id);

export default store;
